import React, { useState, useEffect } from 'react';

import GeocoderZonesSelect from '../../../../shared/components/GeocoderZonesSelect';
import PurchaseTypeSelect from '../ContactDetailsForm/components/inputs/PurchaseTypeSelect';
import {
  PropertyKindCheckbox,
  BudgetNumber,
  AreaNumber,
  FloorSelect,
  ElevatorSelect,
  RenovationRadio,
  OutdoorSpaceSelect,
  FinancingStateSelect,
  HuntInterestSelect,
  FreeFieldTextArea,
  RoomRadio,
  BedroomRadio
} from './components/Inputs';

const Criterias = ({ buyerAlert, setStateBuyerAlert, errors, showBuyerSpaceFields = false }) => {
  const [zones, setZones] = useState(buyerAlert.zone || [])
  const commonProps = { buyerAlert, setStateBuyerAlert, errors };

  useEffect(() => {
    // Set criterias from URL params if present, then clean the URL
    const urlParams = new URLSearchParams(window.location.search);
    const updates = {};

    const zoneParam = urlParams.get('zone');
    if (zoneParam) {
      try {
        const parsedZone = JSON.parse(zoneParam);
        const cleanedZones = parsedZone.map(zone => zone.replace(/ Tous$/, ''));
        updates.zone = cleanedZones;
        setZones(cleanedZones);
      } catch (e) {
        console.error('Error parsing zone parameter:', e);
      }
    }

    if (urlParams.get('apartment') === 'true') updates.apartment = true;
    if (urlParams.get('house') === 'true') updates.house = true;

    const minBudget = urlParams.get('min_budget');
    const maxBudget = urlParams.get('max_budget');
    const minArea = urlParams.get('min_area');
    const minRoomNumber = urlParams.get('min_room_number');
    const minBedroomNumber = urlParams.get('min_bedroom_number');

    if (minBudget) updates.min_budget = minBudget;
    if (maxBudget) updates.max_budget = maxBudget;
    if (minArea) updates.min_area = minArea;
    if (minRoomNumber) updates.min_room_number = parseInt(minRoomNumber, 10);
    if (minBedroomNumber) updates.min_bedroom_number = parseInt(minBedroomNumber, 10);

    if (Object.keys(updates).length > 0) {
      setStateBuyerAlert({ ...buyerAlert, ...updates });
    }

    if (urlParams.toString()) {
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
  }, []);

  useEffect(() => {
    if (!buyerAlert.id) return;

    setZones(buyerAlert.zone)
  }, [buyerAlert]);

  const handleZonesChange = (zones) => {
    setZones(zones)
    setStateBuyerAlert({ ...buyerAlert, zone: zones })
  }

  return (
    <div data-testid='CriteriasForm'>
      <div className='flex flex-col gap-8 text-sm'>
        <GeocoderZonesSelect
          name='zone'
          label=''
          zones={zones}
          onChange={handleZonesChange}
          placeholder='Entrez une ville, un arrondissement...'
          listPlacement='top-10'
          errors={errors}
        />

        <PropertyKindCheckbox {...commonProps} />

        <div className='flex flex-col md:flex-row gap-5'>
          <BudgetNumber {...commonProps} />

          <AreaNumber {...commonProps} />
        </div>

        <div className='flex flex-col md:flex-row gap-8'>
          <RoomRadio {...commonProps} />

          <BedroomRadio {...commonProps} />
        </div>

        <div className='flex flex-col md:flex-row gap-5'>
          <FloorSelect {...commonProps} />

          <ElevatorSelect {...commonProps} />
        </div>

        <div className='flex flex-col md:flex-row gap-5'>
          <RenovationRadio {...commonProps} />

          <OutdoorSpaceSelect {...commonProps} />
        </div>

        {showBuyerSpaceFields && (
          <>
            <PurchaseTypeSelect
              value={buyerAlert.purchase_type}
              onChange={(e) => setStateBuyerAlert({ ...buyerAlert, purchase_type: e.value })}
              errors={errors}
            />

            <FinancingStateSelect {...commonProps} />

            <HuntInterestSelect {...commonProps} />
          </>
        )}

        <FreeFieldTextArea {...commonProps} />
      </div>
    </div>
  )
}

export default Criterias;
